import './index.css';
import React, { useEffect, useState } from 'react';
import { Flex, Text } from '@smarterservices/smarter-ui';
import { toHumanReadable } from '../../helpers/helpers';
import DualPane from '../DualPane';
import { usePaneViewer } from '../PaneViewer';
import Loader from '../Common/Loader';
import { useAppStore } from '../../stores/app';

const WelcomeScreen = ({ stepData, setIsTaskComplete }) => {
  const [sessionStart, setSessionStart] = useState(null);
  const { setShowNext, onNext, setNextButtonText } = usePaneViewer();
  const { getSessionStartData, setPageErrorText } = useAppStore();
  const GET_STEP_TIMEOUT = 60; // number of seconds before timing out

  useEffect(() => {
    // get session start information to display on screen
    const initSessionStart = async () => {
      // TODO: if this hard fails we need to make sure it is properly handled...
      const sessionStartData = await getSessionStartData();
      setSessionStart(sessionStartData);
      
      setNextButtonText(stepData?.nextStepButton);
    };
    initSessionStart();
    
    setIsTaskComplete(true);
  }, []);
  return (
    <>
      {!sessionStart && (
        <Loader text="Loading session data..."
                timeout={GET_STEP_TIMEOUT}
                onTimeout={() => setPageErrorText("There was an problem loading the required session data.")} />
      )}
      {stepData && sessionStart && (
        <DualPane
          leftPane={
            <Flex direction="column">
              <Text as="h3" size="medium">
                {stepData.examDetails.course}
              </Text>
              <Flex margin="0 0 medium 0">
                <Text>{sessionStart.courseTitle}</Text>
              </Flex>

              <Text as="h3" size="medium">
                {stepData.examDetails.exam}
              </Text>
              <Flex margin="0 0 medium 0">
                <Text>{sessionStart.examTitle}</Text>
              </Flex>

              <Text as="h3" size="medium">
                {stepData.examDetails.duration}
              </Text>
              <Flex margin="0 0 medium 0">
                <Text>
                  {sessionStart.examDuration} {stepData.durationMeasure}
                </Text>
              </Flex>

              {sessionStart.permittedItems &&
                Object.entries(sessionStart.permittedItems).length > 0 && (
                  <>
                    <Text as="h3" size="medium">
                      {stepData.examDetails.permittedItems}
                    </Text>
                    <Flex margin="0 0 medium 0">
                      <ul className="permitted-items">
                        {Object.entries(sessionStart.permittedItems).map(
                          ([key, value]) => (
                            <li key={key}>
                              <Text>
                                {toHumanReadable(key)}
                                {value.notes && ':'}
                                {value.notes && (
                                  <span className="permitted-item-notes">
                                    {value.notes}
                                  </span>
                                )}
                              </Text>
                            </li>
                          )
                        )}
                      </ul>
                    </Flex>
                  </>
                )}

              {sessionStart.studentNotes && (
                <>
                  <Text as="h3" size="medium">
                    {stepData.examDetails.studentNotes}
                  </Text>
                  <Flex margin="0 0 medium 0">
                    <Text>{sessionStart.studentNotes}</Text>
                  </Flex>
                </>
              )}
            </Flex>
          }
          rightPane={
            <div className="vimeo-container">
              <Flex direction="column" alignItems="center" margin="0">
                {stepData?.introductionVideoUrl && (
                  <iframe
                    className="vimeo-iframe"
                    src={stepData?.introductionVideoUrl}
                    allow="fullscreen; picture-in-picture"
                    allowFullScreen
                    title="SmarterProctoring Remote Proctoring"
                  />
                )}
              </Flex>
            </div>
          }
        />
      )}
    </>
  );
};
export default WelcomeScreen;
